import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import faq from "../imgs/faq.svg";
import livechat from "../imgs/livechat.svg";
import report from "../imgs/report.svg";
import review from "../imgs/review.svg";
import whatsapp from "../imgs/whatsapp.svg";
import callus from "../imgs/callus.svg";
import rightarrow from "../imgs/rightarrow.svg";

function Support() {
  const [page, setPage] = useState("support");
  return (
    <div className=" flex">
      <Sidebar page={page} />
      {/* <SecSidebar /> */}
      <div className="w-full ml-[304px]">
        <Navbar page={page} />
        <div className="flex flex-col px-8 gap-6">
          <div className="flex gap-6">
            <div className="border border-[#D7E1F4] w-[337px] p-3 flex gap-[14px] items-center rounded-3xl">
              <img src={faq} alt="" />
              <div className="flex flex-col gap-[9px]">
                <p className="text-[#6882B6] font-semibold text-[16px] leading-7 tracking-[2%]">
                  Frequently Asked Questions
                </p>
                <div className="flex gap-2 ">
                  <p className="leading-[20.32px] text-[#4169E1] text-[16px] font-semibold tracking-[2%]">
                    See more
                  </p>{" "}
                  <img src={rightarrow} alt="" />
                </div>
              </div>
            </div>
            <div className="border border-[#D7E1F4] p-3 w-[371px] flex gap-[14px] items-center rounded-3xl">
              <img src={livechat} alt="" />
              <div className="flex flex-col gap-[9px]">
                <p className="text-[#6882B6] font-semibold text-[16px] leading-7 tracking-[2%]">
                  Live Chat
                </p>
                <div className="flex gap-2 ">
                  <p className="leading-[20.32px] text-[#4169E1] text-[16px] font-semibold tracking-[2%]">
                    Chat Now
                  </p>{" "}
                  <img src={rightarrow} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-6">
            <div className="border border-[#D7E1F4] w-[337px] p-3 flex gap-[14px] items-center rounded-3xl">
              <img src={whatsapp} alt="" />
              <div className="flex flex-col gap-[9px]">
                <p className="text-[#6882B6] font-semibold text-[16px] leading-7 tracking-[2%]">
                  Whatsapp
                </p>
                <div className="flex gap-2 ">
                  <p className="leading-[20.32px] text-[#4169E1] text-[16px] font-semibold tracking-[2%]">
                    Drop a Message
                  </p>{" "}
                  <img src={rightarrow} alt="" />
                </div>
              </div>
            </div>
            <div className="border border-[#D7E1F4] p-3 w-[371px] flex gap-[14px] items-center rounded-3xl">
              <img src={callus} alt="" />
              <div className="flex flex-col gap-[9px]">
                <p className="text-[#6882B6] font-semibold text-[16px] leading-7 tracking-[2%]">
                  Phone Call
                </p>
                <div className="flex gap-2 ">
                  <p className="leading-[20.32px] text-[#4169E1] text-[16px] font-semibold tracking-[2%]">
                    Call Us
                  </p>{" "}
                  <img src={rightarrow} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-6">
            <div className="border border-[#D7E1F4] w-[337px] p-3 flex gap-[14px] items-center rounded-3xl">
              <img src={report} alt="" />
              <div className="flex flex-col gap-[9px]">
                <p className="text-[#6882B6] font-semibold text-[16px] leading-7 tracking-[2%]">
                  Report Our Support
                </p>
                <div className="flex gap-2 ">
                  <p className="leading-[20.32px] text-[#4169E1] text-[16px] font-semibold tracking-[2%]">
                    Not Satisfied?
                  </p>{" "}
                  <img src={rightarrow} alt="" />
                </div>
              </div>
            </div>
            <div className="border border-[#D7E1F4] p-3 w-[371px] flex gap-[14px] items-center rounded-3xl">
              <img src={review} alt="" />
              <div className="flex flex-col gap-[9px]">
                <p className="text-[#6882B6] font-semibold text-[16px] leading-7 tracking-[2%]">
                  Review Our App
                </p>
                <div className="flex bg-[#EFF3FB] items-center w-fit px-1 p-[2px] justify-center rounded-lg">
                  <p className="leading-[20.32px] text-[#4169E1] text-[16px] font-semibold tracking-[2%]">
                    Chat Now
                  </p>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
